<template>
  <div>
    <PageTitle
      title="Document Upload Create"
      :backBtn="true"
      :showLoading="isLoading"
    />
    <v-container fluid class="lighten-12 container">
      <ValidationObserver ref="observer">
        <v-card>
          <v-card-title>General</v-card-title>
          <v-container fluid>
            <v-row>
              <v-col v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Name"
                  rules="required"
                  vid="name"
                >
                  <v-text-field
                    outlined
                    v-model="DocumentUploadList.name"
                    :error-messages="errors"
                    dense
                    required
                    hide-details="auto"
                    label="Name"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="DocumentType"
                  dense
                  rules="required"
                >
                  <v-autocomplete
                    v-model="DocumentUploadList.type_id"
                    item-text="name"
                    item-value="id"
                    :items="documentUploadType"
                    :error-messages="errors"
                    :loading="loadingDocumentType"
                    :search-input.sync="searchDocumentType"
                    outlined
                    required
                    dense
                    hide-details="auto"
                    label="Document Type"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-col>
              <v-col v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <ValidationProvider
                  name="Date"
                  rules="required"
                  v-slot="{ errors }"
                  vid="date"
                >
                  <datePickComponent
                    v-model="DocumentUploadList.date"
                    :labelname="'Date'"
                    :errorMessages="errors"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>Description</v-card-title>
              <v-container fluid>
                <v-row>
                  <v-col>
                    <v-textarea
                      rows="3"
                      outlined
                      v-model="DocumentUploadList.description"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>Files</v-card-title>
              <v-container fluid>
                <v-row>
                  <v-col>
                    <FileUpload
                      :multiple="true"
                      size="2048"
                      v-model="selectedFiles"
                      showList="true"
                      ref="fileUpload"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>

        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn depressed small class="text-white btn_medium" @click="clear"
            >Clear</v-btn
          >
          <v-btn
            depressed
            small
            class="text-white btn_blue btn_medium w-100"
            @click="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import datePickComponent from '../../../components/base/DateComponent';
import { DocumentUploadType } from '../../../models/DocumentUploadType';
import { required, email, max, numeric } from 'vee-validate/dist/rules';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
  withValidation,
} from 'vee-validate';
import _ from 'lodash';

import * as moment from 'moment/moment';
import FileUpload from '@/components/base/FileUpload';
import store from '../../../store/store';
import axios from '@/plugins/axios';
extend('required', {
  ...required,
  message: '{_field_} is required',
});
extend('numeric', {
  ...numeric,
  message: 'input must be numeric',
});
export default {
  data: () => ({
    selectedFiles: '',
    messages: [],
    DocumentUploadList: {},
    errors: [],
    selectedDocumentUploads: [],
    documentUploadTypes: [new DocumentUploadType()],
    searchDocumentType: null,
    loadingDocumentType: false,
  }),
  components: {
    ValidationProvider,
    ValidationObserver,
    datePickComponent,
    FileUpload,
  },

  methods: {
    async submit() {
      this.clickSubmit = true;
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.CreateDocumentUpload();
      } else {
        this.clickSubmit = false;
      }
    },

    CreateDocumentUpload() {
      this.isLoading = true;
      let error = false;
      if (!error) {
        // let credential = this.DocumentUploadList;

        this.$store
          .dispatch(
            'DocumentUpload/CreateDocumentUpload',
            this.DocumentUploadList,
          )
          .then((res) => {
            if (this.selectedFiles) {
              var fileId = res.data.id;
              var files = this.selectedFiles;
              var documentType = 'DOCUMENTUPLOAD';
              this.$store
                .dispatch('DocumentUploads', {
                  fileId,
                  files,
                  documentType,
                })
                .then((resp) => {});
            }
            this.$toast.success('Document created successfully');
            this.isLoading = false;
            this.$router.push(`/document-uploads`);
          })
          .catch((err) => {
            this.$refs.observer.setErrors(err.data.error);
            this.$toast.error('Document creation failed');
            this.isLoading = false;
            this.messages = err.data.title;
          });
      }
    },

    GetDocumentUploadTypes() {
      this.loadingDocumentType = true;
      axios
        .get('document-types')
        .then((res) => {
          this.documentUploadType = res.data.data;
          this.loadingDocumentType = false;
        })
        .catch((err) => {
          this.loadingDocumentType = false;
          this.messages.push(err.data.title);
        });
    },
    GetDocumentTypesByQuery(query = '') {
      this.loadingDocumentType = true;
      this.$store
        .dispatch('document-upload/GetDocumentTypeSearch', {
          query: query,
          status: 'active',
        })
        .then((res) => {
          this.documentUploadType = new DocumentUploadType().MapData(res.data);
          this.loadingDocumentType = false;
        })
        .catch((err) => {});
    },

    clear() {
      this.isDocumentUploadListValid = '';

      this.$refs.fileUpload.removeAllItems();
      this.selectedDocumentUploads = [];
      this.DocumentUploadList = {};
      this.$refs.fileUpload.this.$refs.observer.reset();
    },
  },

  created() {
    this.GetDocumentUploadTypes();
  },
};
</script>
